import { render, staticRenderFns } from "./ProposalTutorialSlider.vue?vue&type=template&id=20f45f22"
import script from "./ProposalTutorialSlider.vue?vue&type=script&lang=js"
export * from "./ProposalTutorialSlider.vue?vue&type=script&lang=js"
import style0 from "./ProposalTutorialSlider.vue?vue&type=style&index=0&id=20f45f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports